const { BE, FE } = require('./environmentUrl.js');

module.exports = {
  paytmbank: {
    port: 3009,
    redis: {
      host: '127.0.0.1',
      port: 6379,
    },
    oauth: {
      endpoint: 'https://accounts-staging.paytm.in',
      clientId: 'oe-paytmbank-onboarding',
      scope: 'paytm',
      responseType: 'code',
      redirectURI: '/token',
    },
    goldenGate: {
      endpoint: 'https://goldengate-staging7.paytmbank.com',
    },
    insurance: {
      endpoint: 'https://staging.paytm.com/protection',
    },
    dms: {
      endpoint: 'https://dms-staging.paytmbank.com',
    },
    fsm: {
      endpoint: 'https://fse-staging.paytm.com',
    },
    tms: {
      endpoint: 'https://tms-staging.paytm.com',
    },
    uad: {
      endpoint: 'https://uad-staging.paytm.com',
    },
    host: 'https://oe-staging5.paytmbank.com',
    loggerPath: '/tmp',
  },
  paytm: {
    version: '3.4.7',
    port: 3009,
    redis: {
      host: '127.0.0.1',
      port: 6379,
    },
    oauth: {
      endpoint: 'https://accounts-staging.paytm.in',
      clientId: 'OE-panel-staging',
      scope: 'paytm',
      responseType: 'code',
      redirectURI: '/token',
    },
    goldenGate: {
      endpoint: 'https://goldengate-staging5.paytm.com',
      appEndpoint: 'paytmgg://goldengate-app/',
    },
    insurance: {
      endpoint: 'https://staging.paytm.com/protection',
    },
    dms: {
      endpoint: 'https://dms-staging.paytm.com',
    },
    cbrDs: {
      endpoint: 'https://dms-staging.paytm.com',
    },
    fsm: {
      endpoint:
        (BE[process.env.REACT_APP_BE_ENV.trim()] &&
          BE[process.env.REACT_APP_BE_ENV.trim()].endpoint) ||
        'https://fse-staging.paytm.com',
      mapMyIndiaKey: '',
      mmiEndpoint: 'https://apis.mappls.com/advancedmaps/v1',
      mapType: 'mapMyIndia',
    },
    tms: {
      endpoint: 'https://tms-staging.paytm.com',
    },
    ump: {
      endpoint: 'https://ump-staging.paytm.com',
    },
    uad: {
      endpoint: 'https://uad-staging.paytm.com',
    },
    oe: {
      endpoint: 'https://oe-staging6.paytm.com',
    },
    host: `${
      (FE[process.env.REACT_APP_FE_ENV.trim()] &&
        FE[process.env.REACT_APP_FE_ENV.trim()].endpoint) ||
      'https://fse-nonprod-mgmt-frontend.paytm.com'
    }/v2`,
    loggerPath: '/tmp',
  },
};
